import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _awaitAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/awaitAsyncGenerator.js";
import _wrapAsyncGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/wrapAsyncGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export function getChunkedStream(source) {
  var currentMessageTotalLength = 0;
  var currentMessagePendingLength = 0;
  var currentMessage = null;
  var messageLengthBuffer = null;
  var allocateMessage = function allocateMessage(size) {
    if (typeof size !== "number") {
      throw new Error("Attempted to allocate an event message where size was not a number: " + size);
    }
    currentMessageTotalLength = size;
    currentMessagePendingLength = 4;
    currentMessage = new Uint8Array(size);
    var currentMessageView = new DataView(currentMessage.buffer);
    currentMessageView.setUint32(0, size, false);
  };
  var iterator = /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var sourceIterator, _yield$_awaitAsyncGen, value, done, chunkLength, currentOffset, bytesRemaining, numBytesForTotal, numBytesToWrite;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              sourceIterator = source[Symbol.asyncIterator]();
            case 1:
              if (!true) {
                _context.next = 47;
                break;
              }
              _context.next = 4;
              return _awaitAsyncGenerator(sourceIterator.next());
            case 4:
              _yield$_awaitAsyncGen = _context.sent;
              value = _yield$_awaitAsyncGen.value;
              done = _yield$_awaitAsyncGen.done;
              if (!done) {
                _context.next = 19;
                break;
              }
              if (currentMessageTotalLength) {
                _context.next = 12;
                break;
              }
              return _context.abrupt("return");
            case 12:
              if (!(currentMessageTotalLength === currentMessagePendingLength)) {
                _context.next = 17;
                break;
              }
              _context.next = 15;
              return currentMessage;
            case 15:
              _context.next = 18;
              break;
            case 17:
              throw new Error("Truncated event message received.");
            case 18:
              return _context.abrupt("return");
            case 19:
              chunkLength = value.length;
              currentOffset = 0;
            case 21:
              if (!(currentOffset < chunkLength)) {
                _context.next = 45;
                break;
              }
              if (currentMessage) {
                _context.next = 33;
                break;
              }
              bytesRemaining = chunkLength - currentOffset;
              if (!messageLengthBuffer) {
                messageLengthBuffer = new Uint8Array(4);
              }
              numBytesForTotal = Math.min(4 - currentMessagePendingLength, bytesRemaining);
              messageLengthBuffer.set(value.slice(currentOffset, currentOffset + numBytesForTotal), currentMessagePendingLength);
              currentMessagePendingLength += numBytesForTotal;
              currentOffset += numBytesForTotal;
              if (!(currentMessagePendingLength < 4)) {
                _context.next = 31;
                break;
              }
              return _context.abrupt("break", 45);
            case 31:
              allocateMessage(new DataView(messageLengthBuffer.buffer).getUint32(0, false));
              messageLengthBuffer = null;
            case 33:
              numBytesToWrite = Math.min(currentMessageTotalLength - currentMessagePendingLength, chunkLength - currentOffset);
              currentMessage.set(value.slice(currentOffset, currentOffset + numBytesToWrite), currentMessagePendingLength);
              currentMessagePendingLength += numBytesToWrite;
              currentOffset += numBytesToWrite;
              if (!(currentMessageTotalLength && currentMessageTotalLength === currentMessagePendingLength)) {
                _context.next = 43;
                break;
              }
              _context.next = 40;
              return currentMessage;
            case 40:
              currentMessage = null;
              currentMessageTotalLength = 0;
              currentMessagePendingLength = 0;
            case 43:
              _context.next = 21;
              break;
            case 45:
              _context.next = 1;
              break;
            case 47:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function iterator() {
      return _ref.apply(this, arguments);
    };
  }();
  return _defineProperty({}, Symbol.asyncIterator, iterator);
}